import React from "../../_snowpack/pkg/react.js";
import {Box} from "../../_snowpack/pkg/@chakra-ui/react.js";
export const Root = ({children}) => /* @__PURE__ */ React.createElement(Box, {
  backgroundColor: "gray.900"
}, children);
